import { useEffect, useRef } from 'react';

export default function Particles() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    let frame;
    let points = [];
    const mouse = { x: -1000, y: -1000 };

    const resize = () => {
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = window.innerWidth * ratio;
      canvas.height = window.innerHeight * ratio;
      canvas.style.width = `${window.innerWidth}px`;
      canvas.style.height = `${window.innerHeight}px`;
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      points = Array.from({ length: Math.min(56, Math.floor(window.innerWidth / 22)) }, () => ({
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        vx: (Math.random() - 0.5) * 0.22,
        vy: (Math.random() - 0.5) * 0.22,
        r: Math.random() * 1.6 + 0.4,
      }));
    };

    const draw = () => {
      context.clearRect(0, 0, window.innerWidth, window.innerHeight);
      points.forEach((point, index) => {
        point.x += point.vx;
        point.y += point.vy;
        if (point.x < 0 || point.x > window.innerWidth) point.vx *= -1;
        if (point.y < 0 || point.y > window.innerHeight) point.vy *= -1;
        const distanceToMouse = Math.hypot(point.x - mouse.x, point.y - mouse.y);
        if (distanceToMouse < 130) {
          point.x += (point.x - mouse.x) * 0.006;
          point.y += (point.y - mouse.y) * 0.006;
        }
        context.beginPath();
        context.fillStyle = 'rgba(100, 112, 103, .34)';
        context.arc(point.x, point.y, point.r, 0, Math.PI * 2);
        context.fill();
        for (let next = index + 1; next < points.length; next += 1) {
          const distance = Math.hypot(point.x - points[next].x, point.y - points[next].y);
          if (distance < 110) {
            context.beginPath();
            context.strokeStyle = `rgba(126, 138, 130, ${0.1 * (1 - distance / 110)})`;
            context.moveTo(point.x, point.y);
            context.lineTo(points[next].x, points[next].y);
            context.stroke();
          }
        }
      });
      frame = requestAnimationFrame(draw);
    };

    const onMouse = (event) => { mouse.x = event.clientX; mouse.y = event.clientY; };
    resize();
    draw();
    window.addEventListener('resize', resize);
    window.addEventListener('pointermove', onMouse);
    return () => { cancelAnimationFrame(frame); window.removeEventListener('resize', resize); window.removeEventListener('pointermove', onMouse); };
  }, []);

  return <canvas className="particles" ref={canvasRef} aria-hidden="true" />;
}
